import React from 'react';
import { SpacerVertical, Typography } from '@klarna/bubble-ui';
import { CallToActionButton } from '@/components';
import { ContractOnboardingStatus } from '@mjolnir/mf-fields-ts/src/enm/ContractOnboardingStatus';
import { ExitPoint } from '@/bpc/types/BpcPayload';

export interface ExitPointsComponentProps {
  exitPoints: ExitPoint[];
  t: TranslatorFunction;
  navigateToExitPoint: () => void;
  tPrefix: string;
  exitPointTranslationPath: string | undefined;
  status: ContractOnboardingStatus;
}

const styles = {
  outerContainer: {
    display: 'flex',
    justifyContent: 'flex-start',
  },
};

export default function ExitPointsComponent(
  props: ExitPointsComponentProps,
): React.ReactElement | null {
  const { status, exitPoints, t, tPrefix, navigateToExitPoint, exitPointTranslationPath } = props;

  if (!exitPoints || !exitPoints.length) {
    return null;
  }

  return (
    <>
      {status === ContractOnboardingStatus.ONBOARDING_COMPLETED && (
        <CallToActionButton
          onClick={navigateToExitPoint}
          customOuterContainerStyles={styles.outerContainer}
        >
          {t(`${tPrefix}.button_text`)}
        </CallToActionButton>
      )}

      {exitPointTranslationPath && (
        <Typography
          data-testid="exit-point-message"
          textToken="text-style/text/super-paragraphs/body/regular"
        >
          {t(exitPointTranslationPath)}
        </Typography>
      )}
      <SpacerVertical spaceToken="space/400" />
    </>
  );
}
